import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/content";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>("");

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <SectionHeading
        id="faq"
        eyebrow="FAQ"
        title="关于神马电影网的常见问题"
        description="下面整理了浏览本页时最常遇到的几个问题，包括内容范围、如何查找最新电影与热播剧，以及筛选和搜索的工作方式。"
      />

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
        {faqs.map((item) => {
          const open = openId === item.id;
          return (
            <div
              key={item.id}
              className={`rounded-lg border bg-background-100 transition-colors ${
                open ? "border-accent-300" : "border-background-200"
              }`}
            >
              <button
                type="button"
                onClick={() => setOpenId(open ? "" : item.id)}
                aria-expanded={open}
                className="w-full flex items-start gap-3 p-5 text-left cursor-pointer"
              >
                <span className="mt-0.5 text-accent-500">
                  <i className="ri-question-line text-lg"></i>
                </span>
                <span className="flex-1 font-heading text-base font-semibold text-foreground-950 leading-snug">
                  {item.q}
                </span>
                <i
                  className={`ri-add-line text-xl text-foreground-500 transition-transform duration-300 ${
                    open ? "rotate-45" : ""
                  }`}
                ></i>
              </button>
              <div className={open ? "px-5 pb-5 pl-[52px]" : "hidden px-5 pb-5 pl-[52px]"}>
                <p className="text-sm leading-7 text-foreground-600">{item.a}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}